import styled from "@emotion/styled";
import {FormControl} from "@mui/material";
import {media} from "assets/css/media";

export const PageForm = styled.form`
	display: flex;
	flex-direction: column;
	padding: 30px;
	background: #fff;
`;

export const PageFormTitle = styled.h2`
	color: #333333;
	font-size: 28px;
	font-family: AllProSans, sans-serif;
	font-weight: bold;
	margin-bottom: 30px;
`;

export const PageFormText = styled.div`
	color: #333333;
	font-size: 14px;
	font-family: AllProSans, sans-serif;
	margin-bottom: 20px;
`;

export const FieldWrapper = styled(FormControl)`
	margin-bottom: 20px;

	@media (min-width: ${media.tablet}) {
		max-width: 400px;
	}
`;
